import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pageLoaded: false,
  blinking: false,
  spinStrategies: false,
  checked:false
};

const simulationCommonSlice = createSlice({
  name: 'simulationCommon',
  initialState,
  reducers: {
    setPageLoaded: (state, action) => {
      state.pageLoaded = action.payload;
    },
    setBlinking: (state, action) => {
      state.blinking = action.payload;
    },
    setSpinStrategies: (state, action) => {
      state.spinStrategies = action.payload;
    },
    setChecked: (state, action) => {
      state.checked = action.payload;
    },
  }
});

export const { setPageLoaded, setBlinking, setSpinStrategies, setChecked } = simulationCommonSlice.actions;
export default simulationCommonSlice.reducer;

